import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { CustomTextField } from "../TextFields";

type Props = {
  label: string;
  required?: boolean;
  options: { label: string; id?: string }[];
  defaultValue?: { label: string; id?: string }[];
  error: boolean;
  helperText?: string;
  onChange: (e: { label: string; id?: string }[]) => void;
};
export default function MultiSelectInput({
  required = false,
  defaultValue,
  options,
  error,
  helperText,
  onChange,
  label,
}: Props) {
  return (
    <Autocomplete
      sx={{
        width: "100%",
        "&.MuiAutocomplete-root .MuiOutlinedInput-root": {
          paddingRight: "1rem !important",
        },
        "& .css-p1olib-MuiAutocomplete-endAdornment": {
          right: "unset",
          left: 0,
        },
        "& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment": {
          right: "unset",
          left: "9px",
          pr: 0,
        },
      }}
      multiple
      limitTags={4}
      id="multiple-limit-tags"
      defaultValue={defaultValue}
      options={options}
      getOptionLabel={(option) => option.label}
      renderInput={(params) => (
        <CustomTextField
          required={required}
          {...params}
          error={error}
          helperText={helperText}
          label={label}
        />
      )}
      onChange={(_, value) => onChange(value)}
    />
  );
}

type SelectProps = {
  options: { label: string; value?: any }[];
  defaultValue?: { label: string; value?: any };
  label: string;
  error: boolean;
  helperText?: string;
  onChange: (e: { label: string; value?: any }|null) => void;
  required?: boolean;
};
export function SelectInput({
  error,
  helperText,
  onChange,
  required = false,
  defaultValue,
  label,
  options,
}: SelectProps) {
  return (
    <Autocomplete
      fullWidth
      sx={{
        "& .MuiAutocomplete-endAdornment": {
          right: "unset",
          left: "1rem",
        },
        "& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment": {
          right: "unset",
          left: "1rem",
        },
      }}
      disablePortal
      id="combo-box-demo"
      options={options}
      defaultValue={defaultValue}
      renderInput={(params) => (
        <CustomTextField
          required={required}
          {...params}
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
      onChange={(e, value) => onChange(value)}
    />
  );
}
